import React from 'react';
import { motion } from 'framer-motion';
import { Map, MessageSquare, CheckSquare, Users, ArrowDown } from 'lucide-react';
const assumptions = ['Realtor asume que lender ya confirmó X', 'Lender asume que title lo corrige', 'Title asume que tú ya “entiendes” el timeline', 'Y tú asumes que si nadie te advirtió… no era importante'];
const features = [{
  icon: Map,
  title: '1. Cuándo estás en riesgo',
  description: 'Mapa de Puntos de Riesgo (9 momentos exactos donde se pierde dinero).'
}, {
  icon: MessageSquare,
  title: '2. Qué preguntar',
  description: 'Scripts de Presión Limpia para obtener respuestas claras, no vagas.'
}, {
  icon: CheckSquare,
  title: '3. Confirmación por escrito',
  description: 'Checklists y plantillas para que si no está escrito, no cuente.'
}];
export function SolutionSection() {
  return <section className="py-24 px-4 bg-[#0B0E13] text-[#F5F0E8] relative overflow-hidden" data-id="element-282">
      {/* Background accent */}
      <div className="absolute right-0 top-1/4 w-[500px] h-[500px] bg-[#D4A843]/5 rounded-full blur-[100px] pointer-events-none" data-id="element-283" />

      <div className="max-w-5xl mx-auto" data-id="element-284">
        {/* Assumption Gap Visual */}
        <div className="mb-24" data-id="element-285">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-12" data-id="element-286">
            <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-287">
              El problema real: <br data-id="element-288" />
              <span className="text-[#D4A843]" data-id="element-289">“Confía en tu agente”</span> no
              es una estrategia
            </h2>
            <p className="text-[#8B8578] text-lg max-w-2xl mx-auto" data-id="element-290">
              Sí, un buen realtor ayuda muchísimo. Pero incluso con buen agente,
              las pérdidas pasan cuando todos asumen cosas:
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8" data-id="element-291">
            {assumptions.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-[#1A1F2E] p-6 rounded-xl border border-[#D4A843]/10 text-center relative" data-id="element-292">
                <Users className="w-8 h-8 text-[#8B8578] mx-auto mb-4 opacity-50" data-id="element-293" />
                <p className="text-sm font-medium text-[#F5F0E8]" data-id="element-294">{item}</p>
                {index < 3 && <div className="hidden lg:block absolute -right-6 top-1/2 -translate-y-1/2 z-10" data-id="element-295">
                    <ArrowDown className="w-6 h-6 text-[#D4A843] -rotate-90" data-id="element-296" />
                  </div>}
                {index < 3 && <div className="lg:hidden absolute left-1/2 -bottom-6 -translate-x-1/2 z-10" data-id="element-297">
                    <ArrowDown className="w-6 h-6 text-[#D4A843]" data-id="element-298" />
                  </div>}
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-[#D4A843]/10 border border-[#D4A843] p-6 rounded-xl text-center max-w-2xl mx-auto" data-id="element-299">
            <p className="text-lg font-bold text-[#D4A843]" data-id="element-300">
              Ese espacio entre “asumir” y “confirmar” es donde se va el dinero.
            </p>
          </motion.div>
        </div>

        {/* Solution Features */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-301">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} data-id="element-302">
            <h3 className="text-2xl md:text-3xl font-serif font-bold mb-6" data-id="element-303">
              Este kit es para compradores que quieren control sin pelear.
            </h3>
            <div className="space-y-6 text-[#8B8578] text-lg" data-id="element-304">
              <p data-id="element-305">
                No necesitas convertirte en experta. Necesitas un sistema simple
                que haga 3 cosas:
              </p>
            </div>
          </motion.div>

          <div className="space-y-6" data-id="element-306">
            {features.map((feature, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.2,
            duration: 0.6
          }} className="flex items-start space-x-4 bg-[#1A1F2E] p-6 rounded-xl border border-[#D4A843]/10" data-id="element-307">
                <div className="bg-[#0F1419] p-3 rounded-lg border border-[#D4A843]/20 shrink-0" data-id="element-308">
                  <feature.icon className="w-6 h-6 text-[#D4A843]" data-id="element-309" />
                </div>
                <div data-id="element-310">
                  <h3 className="text-xl font-bold text-[#F5F0E8] mb-2" data-id="element-311">
                    {feature.title}
                  </h3>
                  <p className="text-[#8B8578]" data-id="element-312">{feature.description}</p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}